(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-feature-split"] && !Shopify.designMode) return;
  try {
    
  class StudioMediaLightbox extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.studio-split__trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog) return;
      this.iframe = this.dialog.querySelector('iframe');
      this.closeBtn = this.dialog.querySelector('.studio-split__dialog-close');

      this.trigger.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('close', () => this.clearIframe());
    }

    open() {
      if (this.iframe && this.iframe.dataset.src && !this.iframe.getAttribute('src')) {
        this.iframe.setAttribute('src', this.iframe.dataset.src);
      }
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    close() {
      if (this.dialog.open && typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.clearIframe();
      }
    }

    clearIframe() {
      if (this.iframe) this.iframe.removeAttribute('src');
    }
  }

  if (!customElements.get('studio-media-lightbox')) {
    customElements.define('studio-media-lightbox', StudioMediaLightbox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-image-carousel"] && !Shopify.designMode) return;
  try {
    
  class StudioCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('.studio-carousel__slide'));
      this.index = 0;

      const prev = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', () => this.scrollByItems(-1));
      if (next) next.addEventListener('click', () => this.scrollByItems(1));

      this.lightbox = this.querySelector('.studio-carousel__lightbox');
      if (this.lightbox) {
        this.lbImg = this.lightbox.querySelector('.studio-carousel__lb-img');
        this.lbCaption = this.lightbox.querySelector('[data-lb-caption]');
        this.slides.forEach((slide, i) => {
          if (slide.tagName === 'BUTTON') slide.addEventListener('click', () => this.openLightbox(i));
        });
        const close = this.lightbox.querySelector('[data-lb-close]');
        const lbPrev = this.lightbox.querySelector('[data-lb-prev]');
        const lbNext = this.lightbox.querySelector('[data-lb-next]');
        if (close) close.addEventListener('click', () => this.lightbox.close());
        if (lbPrev) lbPrev.addEventListener('click', () => this.step(-1));
        if (lbNext) lbNext.addEventListener('click', () => this.step(1));
        this.lightbox.addEventListener('click', (e) => {
          if (e.target === this.lightbox) this.lightbox.close();
        });
      }
    }

    scrollByItems(dir) {
      if (!this.track || !this.slides.length) return;
      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const amount = this.slides[0].getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: amount * dir, behavior: 'smooth' });
    }

    openLightbox(i) {
      this.index = i;
      this.render();
      if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
      else this.lightbox.setAttribute('open', '');
    }

    step(dir) {
      this.index = (this.index + dir + this.slides.length) % this.slides.length;
      this.render();
    }

    render() {
      const slide = this.slides[this.index];
      if (slide && this.lbImg) {
        this.lbImg.src = slide.dataset.full || '';
        this.lbImg.alt = slide.dataset.alt || '';
      }
      if (this.lbCaption) {
        const name = slide ? (slide.dataset.name || '') : '';
        this.lbCaption.textContent = name;
        this.lbCaption.hidden = name === '';
      }
    }
  }

  if (!customElements.get('studio-carousel')) {
    customElements.define('studio-carousel', StudioCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
